import React from 'react';

import { Select } from '@wds/select';
import { Box } from '@wds/box';
import { IconCaretDown, IconGlobe } from '@wds/icons';
import { Typography } from '@wds/typography';
import { Menu } from '@wds/menu';

import PropTypes from 'prop-types';
import STRINGS from '../../../constants';

const LanguageSelector = (props) => {
	const { languages, currentLanguage, setCurrentLanguage, type } = props;

	const handleChangeSelectedLanguage = (e) => {
		setCurrentLanguage(e.currentTarget.value);
	};

	const LanguageOptions = Object.entries(languages).map((language) => {
		if (type === 'select') {
			return (
				<Select.Option key={language[0]} value={language[0]}>
					{language[1]}
				</Select.Option>
			);
		}
		return (
			<Menu.Item key={`menuItem-${language[0]}`} onClick={() => setCurrentLanguage(language[0])}>
				{language[1]}
			</Menu.Item>
		);
	});

	const navBarItemProps = {
		mx: 4,
		style: {
			color: '#efefef',
			cursor: 'pointer',
			fontSize: '1.5rem',
		},
	};

	return (
		type === 'select' ? (
			<Select
				id='sma-language-selector'
				aria-label='language selector dropdown'
				tabIndex='0'
				onChange={handleChangeSelectedLanguage}
				addOn={<IconGlobe color='primary' title='Translation Globe Icon' />}
				value={currentLanguage}
			>
				{LanguageOptions}
			</Select>
		) : (
			<Menu
				id='sma-language-selector'
				aria-label='language selector menu'
				tabIndex='0'
				stretched
				menuTrigger={(
					<div>
						<Box
							display='flex'
							justifyContent='space-around'
							alignItems='center'
							gap={0}
						>
							<Box {...navBarItemProps}>
								<Typography
									color='light'
									weight='medium'
									variant='body'
								>
									{currentLanguage.toUpperCase()}
								</Typography>
							</Box>
							<IconCaretDown color='light' size='sm' aria-label={STRINGS.labels.chevronDown} />
						</Box>
					</div>
				)}
				noRules
				noMaxHeight
				placement='bottom-left'
			>
				{LanguageOptions}
			</Menu>
		)
	);
};

LanguageSelector.propTypes = {
	languages: PropTypes.object.isRequired,
	currentLanguage: PropTypes.string.isRequired,
	setCurrentLanguage: PropTypes.func.isRequired,
	type: PropTypes.string,
};
LanguageSelector.defaultProps = { type: 'select' };

export default LanguageSelector;
